<template>
  <div>
    <!-- <div class="bannerW">
      <el-image
        :src="require('@/assets/img/cooperation.jpg')"
        fit="cover"
        class="banner"
      ></el-image>
      <div class="titleBox">
        <h2>合作伙伴</h2>
        <p>PARTNERS</p>
      </div>
    </div> -->
    <Banner :classType=8 />

    <div class="wrap wow animate__slideInUp">
      <div class="cooperationBox">
        <div
          class=""
          :key="idx"
          v-for="(item, idx) in logoList"
        >
          <div class="item">
            <el-image :src="item" fit="contain"></el-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import Banner from "@/views/components/Banner";

export default {
  data() {
    return {
      num: 20,
      logoList: [],
    };
  },
  components: {
    Banner,
  },
  mounted() {
    this.$api.partners().then((res) => {
      const { PicList } = res.Value;
      this.logoList = PicList;
      this.$nextTick(() => {
        new WOW({
          boxClass: "wow",
          animateClass: "animate__animated",
          live: false,
        }).init();
      });
    });
  },
};
</script>

<style lang="scss">
.cooperationBox {
  display: grid;
  padding: 50px 0;
  grid-gap: 40px 40px;
  grid-template-columns: repeat(4, auto);
}
</style>